function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExitFullScreen = function SvgExitFullScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M35.486 8.663v3.847h-11.1c-1.227 0-2.221-.861-2.221-1.924V.97h4.44v7.694ZM4.403 8.663v3.847h11.101c1.226 0 2.22-.861 2.22-1.924V.97h-4.44v7.694ZM35.486 20.203v-3.846h-11.1c-1.227 0-2.221.86-2.221 1.923v9.617h4.44v-7.694zM4.403 20.203v-3.846h11.101c1.226 0 2.22.86 2.22 1.923v9.617h-4.44v-7.694z",
    style: {
      strokeWidth: 2.25439
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "10.6667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif"
    },
    x: 7.516,
    y: 39.211
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.516,
    y: 39.211,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "MIN")));
};
export default SvgExitFullScreen;